const STATS = {
  WEEK: 'week',
  ONE_MONTH: 'one-month',
  THREE_MONTHS: 'three-months',
  HALF_YEAR: 'half-year',
};

export default STATS;
